module.exports = __webpack_public_path__ + "static/media/embedded-integration.b7da0f5e.md";